import { render, staticRenderFns } from "./PortalAuth.vue?vue&type=template&id=edb8654a&"
import script from "./PortalAuth.vue?vue&type=script&lang=js&"
export * from "./PortalAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports